import React from "react";
import { withRouter } from "react-router-dom";

import { LoveIcon, TvbetIcon } from "@pages/casino/assets/icons";
import { OutlineButtonContainer } from "@pages/casino/assets/styles/mixins";
import { Dropdown, GridDropdown, TabSkeleton } from "@pages/casino/components";
import { IFeelLuckyModal, SearchModal } from "@pages/casino/containers";

import { FilterSearchWrapper, FilterWrapper } from "./elements";
import useController from "./useController";
import { generateAlphabetList } from "./utils";

const GameFilters = ({
	filterValues,
	activeTab,
	showSearch,
	showProvidersFilter,
	showCategoriesFilter,
	showIFeelLucky,
	showFavorites,
	showLetterFilter,
	showSortFilter,
	showTvBet,
	showAllGames,
	sortOptions,
	history,
	onClose,
	onSelectFilter,
	onlySelectFilter,
}) => {
	const {
		helpers: { translate },
		state: {
			isMobile,
			isTablet,
			isDesktop,
			isWide,
			isUltraWide,
			isContainerLoading,
			user,
			categories,
			affiliates,
		},
		handlers: { handleSelectFilter, handleAllGamesButtonClick },
	} = useController({
		history,
		filterValues,
		onSelectFilter,
		activeTab,
		onlySelectFilter,
		showCategoriesFilter,
		showProvidersFilter,
	});

	return (
		<FilterSearchWrapper>
			<FilterWrapper id="casino-filters-container">
				{(isMobile || isTablet) && showSearch && <SearchModal />}

				{showAllGames && (
					<OutlineButtonContainer
						data-testid="button-casino-filter-all-games"
						onClick={handleAllGamesButtonClick}>
						<span>{translate("casino.allGames")}</span>
					</OutlineButtonContainer>
				)}

				{showProvidersFilter && (
					<Dropdown
						isProvidersFilter
						data-testid={onlySelectFilter ? "button-filtered-casino-providers" : "button-casino-filter-providers"}
						onClose={onClose}
						activeTab={activeTab}
						placeholder={translate("casino.providers")}
						name={"provider-dropdown"}
						items={affiliates}
						value={filterValues?.find((item) => item?.section === "provider")}
						onSelect={(value) => {
							const query = `/provider?key=affiliate&name=${value.key}&count=${
								value.count
							}&tab=${activeTab.toLowerCase()}`;

							handleSelectFilter("provider", value, query);
						}}
					/>
				)}

				{showCategoriesFilter && (
					<Dropdown
						data-testid={onlySelectFilter ? "button-filtered-casino-categories" : "button-casino-filter-game-categories"}
						onClose={onClose}
						name={"category-dropdown"}
						isModalDisabled
						items={categories}
						placeholder={translate("casino.categories")}
						value={filterValues?.find((item) => item?.section === "category")}
						onSelect={(value) => {
							const query = `/provider?key=category&name=${
								value.key
							}&tab=${activeTab.toLowerCase()}`;

							handleSelectFilter("category", value, query);
						}}
					/>
				)}

				{showSortFilter && sortOptions?.length > 0 && (
					<Dropdown
						data-testid="button-filtered-casino-sort"
						onClose={onClose}
						items={sortOptions}
						name={"sort-dropdown"}
						placeholder={translate("casino.sort")}
						initialSelectedItem={sortOptions[0]}
						value={filterValues?.find((item) => item?.section === "sort_order")}
						onSelect={(value) => handleSelectFilter("sort_order", value)}
					/>
				)}

				{showLetterFilter && (
					<GridDropdown
						data-testid="button-filtered-casino-alphabetic"
						isModalDisabled
						onClose={onClose}
						name={"category-alphabetic"}
						placeholder={translate("casino.alphabetic")}
						items={generateAlphabetList("alphabetic")}
						value={filterValues?.find((item) => item?.section === "alphabetic")}
						onSelect={(value) => {
							const query = `/provider?key=alphabetic&name=${value.key}`;
							handleSelectFilter("alphabetic", value, query);
						}}
					/>
				)}

				{showTvBet && (
					<OutlineButtonContainer data-testid="button-casino-filter-tvbet" onClick={() => history.push("/tv-games")}>
						<div>
							<TvbetIcon className="tvbet-icon" />
						</div>
					</OutlineButtonContainer>
				)}

				{showIFeelLucky && <IFeelLuckyModal />}

				{isContainerLoading ? (
					<TabSkeleton />
				) : (
					showFavorites &&
					user?.username && (
						<OutlineButtonContainer
							data-testid="button-casino-filter-favorites"
							onClick={() => {
								history.push("/casino-favorites");
							}}>
							<LoveIcon />
							<span>{translate("casino.favorites")}</span>
						</OutlineButtonContainer>
					)
				)}
			</FilterWrapper>

			{(isDesktop || isWide || isUltraWide) && showSearch && (
				<div id="casino-filter-desktop-search">
					<SearchModal activeTab={activeTab} />
				</div>
			)}
		</FilterSearchWrapper>
	);
};

export default withRouter(GameFilters);
